import React from 'react';
import {
  ButtonBack,
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import Spinner from '../../../../../../components/Spinner';
import { ProcessAvailableComponent, ProcessComponent } from './components';
import Modal from '../../../../components/Modal/Modal';
import { BtnRequest } from '../../IssuanceUniversityCard/info/components/styled';
import {
  ProcedureInfoComponent,
  StepsToFollowComponent
} from './components/ProcedureInfoComponent';
import ProcedureHeader from '@/presentation/modules/procedures/components/ContainerProcedure/Header';

const ChangeStudiesOptionInfoView = (props: any) => {
  const {
    procedureSelectedInfo,
    handlerRequest,
    processAvailable,
    handleCloseModalProcessAvailable,
    disabledStudyOption,
    hanlderCloseDisabledStudyOption,
    isCurrentProcess,
    handlerCloseCurrentProcess,
    isRequestInProgress,
    handlerCloseModalRequestInProgress,
    isReincorporatedModal,
    handlerCloseIsReincorporatedModal,
    goBack
  } = props;
  return (
    <div data-testid="cmp-changestudiesoptioninfoview">
      <ContainerProcedure>
        <SubContainer>
          <ButtonBack onClick={goBack} />
          <ProcedureHeader name="Cambio de modalidad" />
        </SubContainer>
        <SubContainer>
          {!procedureSelectedInfo && <Spinner />}
          {procedureSelectedInfo && (
            <>
              <ProcedureHeader
                amount={procedureSelectedInfo?.amount}
                duration={procedureSelectedInfo?.duration}
                date={procedureSelectedInfo?.endDate}
                twoLineFormat
                paddingData={12}
                paddingBottomData={12}
              />
              <ProcedureInfoComponent
              // applySince={procedureSelectedInfo?.detail?.applySince}
              />
              <StepsToFollowComponent />

              <BtnRequest
                data-testid="cmp-btnrequest-change"
                onClick={handlerRequest}
              >
                {' '}
                <p>Empezar solicitud</p>
              </BtnRequest>
            </>
          )}
        </SubContainer>

        <Modal
          show={processAvailable}
          handleClose={handleCloseModalProcessAvailable}
        >
          <ProcessComponent
            hideImage
            handleClick={handleCloseModalProcessAvailable}
            title={procedureSelectedInfo?.error?.title}
            subtitle={procedureSelectedInfo?.error?.description}
            // "Sin embargo, dado que tu carrera no tiene opción Semipresencial o
            // Virtual, la UTP ha equipado, solo para los cursos de tu carrera, las
            // aulas presenciales con cámaras y micrófonos, de tal manera que las
            // clases presenciales serán transmitidas en vivo y además quedarán
            // grabadas. Si en alguna ocasión no puedes asistir, puedes ver la clase
            // en vivo o luego puedes ver la clase grabada en la plataforma. Recuerda
            // que las evaluaciones son presenciales."
          />
        </Modal>

        <Modal
          show={disabledStudyOption}
          handleClose={hanlderCloseDisabledStudyOption}
        >
          <ProcessAvailableComponent
            handleClick={hanlderCloseDisabledStudyOption}
          />
        </Modal>

        <Modal show={isCurrentProcess} handleClose={handlerCloseCurrentProcess}>
          <ProcessComponent
            hideImage
            handleClick={handlerCloseCurrentProcess}
            title="No puedes realizar este trámite"
            subtitle="Ya realizaste una solicitud."
          />
        </Modal>

        <Modal
          show={isRequestInProgress}
          handleClose={handlerCloseModalRequestInProgress}
        >
          <ProcessComponent
            hideImage
            handleClick={handlerCloseModalRequestInProgress}
            title="Trámite en proceso"
            subtitle="Cuentas con una solicitud de Cambio de modalidad para marzo 2023 en proceso, podrás realizar un nuevo trámite en los próximos minutos, cuando hayamos terminado de impactar tu cambio solicitado previamente."
          />
        </Modal>
        <Modal
          show={isReincorporatedModal}
          handleClose={handlerCloseIsReincorporatedModal}
        >
          <ProcessComponent
            hideImage
            handleClick={handlerCloseIsReincorporatedModal}
            title="No puedes realizar este trámite"
            subtitle="Para cambiar de modalidad debes realizar el trámite de "
            linkTo="reincorporación."
          />
        </Modal>
      </ContainerProcedure>
    </div>
  );
};

export default ChangeStudiesOptionInfoView;
